import { render } from "./infoItem.component.vue?vue&type=template&id=092ed6e8&scoped=true&ts=true"
import script from "./infoItem.component.vue?vue&type=script&lang=ts"
export * from "./infoItem.component.vue?vue&type=script&lang=ts"

import "./infoItem.component.vue?vue&type=style&index=0&id=092ed6e8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092ed6e8"]])

export default __exports__